import { DateTime } from 'luxon';

export const formatDateAsTodayOrMonthDay = (selectedDate: string) => {
  if (!selectedDate) return '';

  const date = DateTime.fromISO(selectedDate);
  if (date.hasSame(DateTime.local(), 'day')) return 'today';

  return DateTime.fromISO(selectedDate).toFormat('LLLL d');
};
